import { LinkPreview as LinkPreviewLib } from '@flyerhq/react-native-link-preview';

interface Props {
	text?: string | null;
}

export const LinkPreview = ({ text }: Props) => {
	if (!text) {
		return null;
	}

	return <LinkPreviewLib text={text} renderText={Empty} />;
};

const Empty = () => null;
